import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import { TipoEmendaParlamentar } from './TipoEmendaParlamentar';

function EmendaRowMunicipal({ data, onMore }) {
  return (
    <TableActions key={data.get('id')} data={data} onMore={onMore}>
      <td>{data.get('numeroAno')}</td>
      <td>{data.get('tipoTransferencia')}</td>
      <td>{data.get('origem')}</td>
      <td>{data.get('autores')}</td>
      <td className="right">
        <NumberFormatter value={data.get('valorRepassado')} />
      </td>
    </TableActions>
  );
}

EmendaRowMunicipal.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
  onMore: PropTypes.func.isRequired
};

function EmendaRowFederal({ data, onMore }) {
  return (
    <TableActions key={data.get('id')} data={data} onMore={onMore}>
      <td>{data.get('numeroAno')}</td>
      <td>{data.get('tipoTransferencia')}</td>
      <td>{data.get('origem')}</td>
      <td>{data.get('autores')}</td>
      <td>{data.get('localidadeBeneficiada')}</td>
      <td className="right">
        <NumberFormatter value={data.get('valorPrevisto')} />
      </td>
      <td className="right">
        <NumberFormatter value={data.get('valorRepassado')} />
      </td>
    </TableActions>
  );
}

EmendaRowFederal.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
  onMore: PropTypes.func.isRequired
};

function EmendaTableHeaderMunicipal({ page, searchWithPage }) {
  return (
    <tr>
      <TableHeaderItem
        field="numero"
        label="Número/Ano"
        page={page}
        searchWithPage={searchWithPage}
      />
      <TableHeaderItem
        field="tipoTransferencia"
        label="Tipo de Transferência"
        page={page}
        searchWithPage={searchWithPage}
      />
      <TableHeaderItem
        field="origemEmenda"
        label="Origem da Emenda"
        page={page}
        searchWithPage={searchWithPage}
      />
      <th>Vereadores</th>
      <TableHeaderItem
        field="valorRepassadoPeloConcedente"
        label="Valor Repassado"
        page={page}
        searchWithPage={searchWithPage}
        alignment="right"
      />
      <th />
    </tr>
  );
}

EmendaTableHeaderMunicipal.propTypes = {
  page: PropTypes.instanceOf(Map).isRequired,
  searchWithPage: PropTypes.func.isRequired
};

function EmendaTableHeaderFederal({ page, searchWithPage }) {
  return (
    <tr>
      <TableHeaderItem
        field="numero"
        label="Número/Ano"
        page={page}
        searchWithPage={searchWithPage}
      />
      <TableHeaderItem
        field="tipoTransferencia"
        label="Tipo de Transferência"
        page={page}
        searchWithPage={searchWithPage}
      />
      <TableHeaderItem
        field="origemEmenda"
        label="Origem da Emenda"
        page={page}
        searchWithPage={searchWithPage}
      />
      <th>Autor da Emenda</th>
      <TableHeaderItem
        field="localidadeBeneficiada"
        label="Localidade Beneficiada"
        page={page}
        searchWithPage={searchWithPage}
      />
      <TableHeaderItem
        field="valorPrevisto"
        label="Valor Previsto"
        page={page}
        searchWithPage={searchWithPage}
        alignment="right"
      />
      <TableHeaderItem
        field="valorRepassadoPeloConcedente"
        label="Valor Repassado"
        page={page}
        searchWithPage={searchWithPage}
        alignment="right"
      />
      <th />
    </tr>
  );
}

EmendaTableHeaderFederal.propTypes = {
  page: PropTypes.instanceOf(Map).isRequired,
  searchWithPage: PropTypes.func.isRequired
};

function EmendaFooterMunicipal({ totalizador }) {
  return (
    <tr>
      <td colSpan={4} />
      <td className="right">
        <span>Total: </span>
        <br />
        <NumberFormatter value={totalizador.get('valorTotalRepassado')} />
      </td>
      <td />
    </tr>
  );
}

EmendaFooterMunicipal.propTypes = {
  totalizador: PropTypes.instanceOf(Map).isRequired
};

function EmendaFooterFederal({ totalizador }) {
  return (
    <tr>
      <td colSpan={5} />
      <td className="right">
        <span>Total Previsto: </span>
        <br />
        <NumberFormatter value={totalizador.get('valorTotalPrevisto')} />
      </td>
      <td className="right">
        <span>Total Repassado: </span>
        <br />
        <NumberFormatter value={totalizador.get('valorTotalRepassado')} />
      </td>
      <td />
    </tr>
  );
}

EmendaFooterFederal.propTypes = {
  totalizador: PropTypes.instanceOf(Map).isRequired
};

export default function EmendaTable({
  tipo,
  page,
  totalizador,
  searchWithPage,
  onMore,
  tipoLabel
}) {
  const isMunicipal = tipo === TipoEmendaParlamentar.MUNICIPAL;
  const content = page.get('content', List());

  const renderRow = data => {
    if (isMunicipal) {
      return (
        <EmendaRowMunicipal key={data.get('id')} data={data} onMore={onMore} />
      );
    }
    return (
      <EmendaRowFederal key={data.get('id')} data={data} onMore={onMore} />
    );
  };

  return (
    <div className="panel-table-outer">
      <table className="panel-table striped fancy">
        <TableHeader
          text={`Não foram encontradas Emendas ${tipoLabel}.`}
          empty={content.isEmpty()}
        >
          {isMunicipal ? (
            <EmendaTableHeaderMunicipal
              page={page}
              searchWithPage={searchWithPage}
            />
          ) : (
            <EmendaTableHeaderFederal
              page={page}
              searchWithPage={searchWithPage}
            />
          )}
        </TableHeader>
        <tbody>{content.map(renderRow)}</tbody>
        {!content.isEmpty() && (
          <tfoot>
            {isMunicipal ? (
              <EmendaFooterMunicipal totalizador={totalizador} />
            ) : (
              <EmendaFooterFederal totalizador={totalizador} />
            )}
          </tfoot>
        )}
      </table>
    </div>
  );
}

EmendaTable.propTypes = {
  tipo: PropTypes.oneOf(Object.values(TipoEmendaParlamentar)).isRequired,
  page: PropTypes.instanceOf(Map).isRequired,
  totalizador: PropTypes.instanceOf(Map).isRequired,
  searchWithPage: PropTypes.func.isRequired,
  onMore: PropTypes.func.isRequired,
  tipoLabel: PropTypes.string.isRequired
};
